import { buildExportFileName } from "./timeFormatUtils";

/**
 * Universal file download helper.
 * Handles Base64 strings, Blobs, ArrayBuffers, and fetch Responses.
 */
export const downloadBase64File = async (data, moduleName, fileName = null) => {
    try {
        const finalFileName = fileName || buildExportFileName(moduleName);
        let blob;

        console.log("🧩 Download handler type:", typeof data, data);

        if (data instanceof Response) {
            blob = await data.blob();
        }
        else if (data instanceof Blob) {
            blob = data;
        }
        else if (data instanceof ArrayBuffer) {
            blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
        }
        else if (typeof data === "string") {
            const base64Data = data.includes("base64,")
                ? data.split("base64,")[1]
                : data.trim();

            try {
                const byteCharacters = atob(base64Data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                blob = new Blob([byteArray], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
            } catch (err) {
                console.warn("⚠️ Not valid Base64 — treating as plain text");
                blob = new Blob([data], { type: "text/plain" });
            }
        } else {
            throw new Error("Unsupported data type for download");
        }

        if (!blob) throw new Error("Blob creation failed");

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = finalFileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        console.log(`✅ File downloaded: ${finalFileName}`);
        return true;
    } catch (err) {
        console.error("❌ Download failed:", err);
        return false;
    }
};
